import { TransactionActionType } from "./transaction-approval-dialog.types";
import { FormlyFieldConfigTranslatable } from "../../../../shared/types/form";

export function getTransactionActionFormFields(actionType: TransactionActionType): FormlyFieldConfigTranslatable[] {
  const isRejection = actionType === "rejection";

  return [
    {
      fieldGroupClassName: "flex flex-col gap-5",
      fieldGroup: [
        {
          type: "wysiwyg",
          key: "actionMessage",
          props: {
            label: {
              en: isRejection ? "Rejection reason" : "Approval message (optional)",
              fi: isRejection ? "Hylkäämisen syy" : "Hyväksyntäviesti (valinnainen)",
              sv: isRejection ? "Avvisningsorsak" : "Godkännandemeddelande (valfritt)",
              no: isRejection ? "Avvisningsgrunn" : "Godkjenningsmelding (valgfritt)",
            },
            required: isRejection,
            translatable: false,
          },
        },
      ],
    },
  ];
}
